"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cache = require("@stt-componentes/cache");
var _SttAlerta = _interopRequireDefault(require("./SttAlerta"));
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var ActionFnMap = {
  "SINCRONIZAR_LOCAL_STORAGE": function SINCRONIZAR_LOCAL_STORAGE(_ref) {
    var config = _ref.config,
      data = _ref.data,
      onSync = _ref.onSync;
    for (var item in data) {
      if (Object.hasOwnProperty.call(data, item)) {
        var valueItem = data[item];
        if (valueItem) {
          localStorage.setItem(item, valueItem);
        }
      }
    }
    onSync(true);
  },
  "REDIRECT_LOGIN": function REDIRECT_LOGIN(_ref2) {
    var config = _ref2.config,
      data = _ref2.data,
      redirectUrl = _ref2.redirectUrl;
    var AUTH_URL = config.url_base_oauth2;
    var CALLBACK_URL = config.url_base_callback;
    if (redirectUrl) {
      window.location.href = redirectUrl;
    } else {
      var OAUTH_CALLBACK_URL = "".concat(AUTH_URL, "/?redirect_uri=").concat(encodeURI(CALLBACK_URL));
      window.location.href = OAUTH_CALLBACK_URL;
    }
  },
  "LOGOUT": function LOGOUT(_ref3) {
    var config = _ref3.config,
      redirectUrl = _ref3.redirectUrl;
    _cache.Cache.clear();
    var AUTH_URL = config.url_base_oauth2;
    var CALLBACK_URL = config.url_base_callback;
    if (redirectUrl) {
      window.location.href = redirectUrl;
    } else {
      var OAUTH_CALLBACK_URL = "".concat(AUTH_URL, "/?redirect_uri=").concat(encodeURI(CALLBACK_URL));
      window.location.href = OAUTH_CALLBACK_URL;
    }
  },
  "REDIRECT_MEUS_DADOS": function REDIRECT_MEUS_DADOS(_ref4) {
    var config = _ref4.config;
    var token = _cache.Cache.getAccessToken();
    var userInfo = _cache.Cache.getUserInfo();
    var AUTH_URL = config.url_base_oauth2;

    // Usado para redirecionar usuários que possuem usuario_externo na RCTM e estão usando o STT em outra instância.
    // Exemplo: clicou em "alterar meus dados" na UFSC e vai para a RCTM.
    if (userInfo.origem === 'STT - RCTM' && config.url_base_oauth2_rctm) {
      var API_RCTM_AUTH_URL = config.url_base_api_oauth2;
      var RCTM_AUTH_URL = config.url_base_oauth2_rctm;
      _axios["default"].post("".concat(API_RCTM_AUTH_URL, "/auth/login-externo"), {}, {
        headers: {
          Authorization: "Bearer ".concat(token)
        }
      }).then(function (response) {
        var tokenRCTM = response.data.access_token;
        var URL_REDIRECT = "".concat(RCTM_AUTH_URL, "/meus-dados?token=").concat(tokenRCTM);
        window.open(URL_REDIRECT, 'blank');
      })["catch"](function (error) {
        console.log(error);
        var URL_REDIRECT = "".concat(RCTM_AUTH_URL, "/meus-dados");
        window.open(URL_REDIRECT, 'blank');
      });
      return;
    }
    var URL_REDIRECT = "".concat(AUTH_URL, "/meus-dados");
    window.open(URL_REDIRECT, 'blank');
  },
  "REDIRECT_INICIO": function REDIRECT_INICIO(_ref5) {
    var config = _ref5.config;
    var token = _cache.Cache.getAccessToken();
    var userInfo = _cache.Cache.getUserInfo();
    var AUTH_URL = config.url_base_oauth2;

    // Usado para redirecionar usuários que possuem usuario_externo na RCTM e estão usando o STT em outra instância.
    // Exemplo: clicou em "alterar meus dados" na UFSC e vai para a RCTM.
    if (userInfo.origem === 'STT - RCTM' && config.url_base_oauth2_rctm) {
      var API_RCTM_AUTH_URL = config.url_base_api_oauth2;
      var RCTM_AUTH_URL = config.url_base_oauth2_rctm;
      _axios["default"].post("".concat(API_RCTM_AUTH_URL, "/auth/login-externo"), {}, {
        headers: {
          Authorization: "Bearer ".concat(token)
        }
      }).then(function (response) {
        var tokenRCTM = response.data.access_token;
        var URL_REDIRECT = "".concat(RCTM_AUTH_URL, "/inicio?token=").concat(tokenRCTM);
        window.open(URL_REDIRECT, 'blank');
      })["catch"](function (error) {
        console.log(error);
        var URL_REDIRECT = "".concat(RCTM_AUTH_URL, "/inicio");
        window.open(URL_REDIRECT, 'blank');
      });
      return;
    }
    var URL_REDIRECT = "".concat(AUTH_URL, "/inicio");
    window.open(URL_REDIRECT, 'blank');
  }
};
var useHrefQuery = function useHrefQuery() {
  return new URLSearchParams(window.location.href);
};
var useQuery = function useQuery() {
  return new URLSearchParams(window.location.search);
};

/**
* Modos de autenticação
* - LEGADO: Autenticação com a antiga arquitetura.
* - DEFAULT: Autenticação com refresh token.
* - RACF - [R]estaurar [A]cesso [C]om [F]ocus - Autenticação sem refresh token + restaurar tempo de acesso com focus.
* - RASF - [R]estaurar [A]cesso [S]em [F]ocus - Autenticação sem refresh token + restaurar tempo de acesso sem focus.
*/
var MODOS = {
  "LEGADO": {
    pathIFrame: "/CacheManager",
    ignorarFocus: false,
    habilitarRestaurarTempoAcesso: false
  },
  "DEFAULT": {
    pathIFrame: "/CacheManagerCRT",
    ignorarFocus: false,
    habilitarRestaurarTempoAcesso: false
  },
  "RACF": {
    pathIFrame: "/CacheManagerSRT",
    ignorarFocus: false,
    habilitarRestaurarTempoAcesso: true
  },
  "RASF": {
    pathIFrame: "/CacheManagerSRT",
    ignorarFocus: true,
    habilitarRestaurarTempoAcesso: true
  }
};
var ALERTS = {
  "PRE_TIMEOUT": {
    title: "Atenção!",
    renderMessage: function renderMessage(tempoRestanteSeg) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "O sistema est\xE1 sem uso por um per\xEDodo muito longo. ", /*#__PURE__*/_react["default"].createElement("br", null), " Por motivos de seguran\xE7a, a sess\xE3o ser\xE1 encerrada. ", /*#__PURE__*/_react["default"].createElement("br", null), " Tempo Restante: ", tempoRestanteSeg, " segundos ", /*#__PURE__*/_react["default"].createElement("br", null), "  Clique em Ok para reestabelecer a sess\xE3o.");
    }
  },
  "TIMEOUT": {
    title: "Atenção!",
    renderMessage: function renderMessage() {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "O sistema ficou sem uso por um per\xEDodo muito longo. Por motivos de seguran\xE7a, a sess\xE3o foi encerrada. ", /*#__PURE__*/_react["default"].createElement("br", null), " Para continuar utilizando o sistema ser\xE1 necess\xE1rio fazer a autentica\xE7\xE3o novamente.");
    }
  }
};
var CacheAlert = function CacheAlert(_ref6) {
  var openAlert = _ref6.openAlert,
    _ref6$tempoRestanteSe = _ref6.tempoRestanteSeg,
    tempoRestanteSeg = _ref6$tempoRestanteSe === void 0 ? 0 : _ref6$tempoRestanteSe,
    handleOnClose = _ref6.handleOnClose,
    handleReativarUsuario = _ref6.handleReativarUsuario;
  if (tempoRestanteSeg > 60) return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
  var estado = tempoRestanteSeg === 0 ? "TIMEOUT" : "PRE_TIMEOUT";
  var onClose = estado === "TIMEOUT" ? handleOnClose : handleReativarUsuario;
  var options = [{
    title: 'Ok',
    onClick: onClose
  }];
  return /*#__PURE__*/_react["default"].createElement(_SttAlerta["default"], {
    open: openAlert,
    title: ALERTS[estado].title,
    message: ALERTS[estado].renderMessage(tempoRestanteSeg),
    type: "alert",
    options: options,
    onClose: onClose,
    blurBackground: true
  });
};

/**
 * Lógica para restaurar tempo de acesso.
 */
var RestaurarTempoAcesso = function RestaurarTempoAcesso(_ref7) {
  var config = _ref7.config,
    ignorarFocus = _ref7.ignorarFocus,
    redirectUrl = _ref7.redirectUrl;
  var poolingTimeInSeconds = config.auth_polling_time_seconds || 10;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    openAlert = _useState2[0],
    setOpenAlert = _useState2[1];
  var _useState3 = (0, _react.useState)(true),
    _useState4 = _slicedToArray(_useState3, 2),
    hasFocus = _useState4[0],
    setFocus = _useState4[1]; // Para controlar o focus da tela
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    session = _useState6[0],
    setSession = _useState6[1]; // Informações do login
  var _useState7 = (0, _react.useState)(true),
    _useState8 = _slicedToArray(_useState7, 2),
    enableRequest = _useState8[0],
    setEnableRequest = _useState8[1]; // Para bloquear as requests depois que teve timeout.
  var _useState9 = (0, _react.useState)(0),
    _useState10 = _slicedToArray(_useState9, 2),
    tempoRestanteSeg = _useState10[0],
    setTempoRestanteSeg = _useState10[1];

  /**
   * RN1 - Garantinar para status 401, que o usuário não possui mais acesso.
   * RN2 - Para os demais erros. Não deve rediricionar ou bloquear, deve continuar com o timeout da sessão.
   */
  var handleError = function handleError(_ref8) {
    var response = _ref8.response;
    if ((response === null || response === void 0 ? void 0 : response.status) === 401) {
      setOpenAlert(true);
      setTempoRestanteSeg(0);
      setEnableRequest(false);
    }
  };
  var handleOnClose = function handleOnClose() {
    ActionFnMap['LOGOUT']({
      config: config,
      redirectUrl: redirectUrl
    });
  };
  var handleTempoAcesso = function handleTempoAcesso(data) {
    setSession(data);
  };

  /**
   * Restaura o timeout do usuário
   */
  var handleReativarUsuario = function handleReativarUsuario() {
    _cache.Autenticacao.restaurarTempoAcesso(config).then(function (_ref9) {
      var data = _ref9.data;
      setOpenAlert(false);
      handleTempoAcesso(data);
    })["catch"](function (err) {
      handleError(err);
    });
  };

  /**
   * Verificar o tempo de acesso. 
   * Serve para sincronizar o timeout entre as abas.
   */
  var handleVerificarTempoAcesso = function handleVerificarTempoAcesso() {
    _cache.Autenticacao.verificarTempoAcesso(config).then(function (_ref10) {
      var data = _ref10.data;
      handleTempoAcesso(data);
    })["catch"](function (err) {
      handleError(err);
    });
  };

  // Lógica para atualizar o tempoRestanteSegundos
  (0, _react.useEffect)(function () {
    var intervalId;
    if (session) {
      var dt_ultima_atualizacao = session.dt_ultima_atualizacao,
        expireInSeconds = session.expireInSeconds; // login, dt_primeiro_acesso
      intervalId = setInterval(function () {
        var tempoRestanteSegundos = Math.round((expireInSeconds * 1000 - (Date.now() - dt_ultima_atualizacao)) / 1000);
        if (tempoRestanteSegundos <= 0) {
          setOpenAlert(true);
          setTempoRestanteSeg(0);
        } else if (tempoRestanteSegundos <= 60) {
          setOpenAlert(true);
          setTempoRestanteSeg(tempoRestanteSegundos);
        }
      }, 1000);
    }
    return function () {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [session]);

  // Estado inicial para o focus da aplicação.
  (0, _react.useEffect)(function () {
    setFocus(document.hasFocus());
  }, []);

  // Regra para restaurar tempo de acesso.
  (0, _react.useEffect)(function () {
    var intervalId = setInterval(function () {
      /**
       * 1 - enableRequest, controla o bloqueia das requisições com o servidor.
       * 2 - Se ignorarFocus = True, considera sempre reativarUsuario.
       * 3 - Se hasFocus = True, deve reativarUsuario, do contrário verificarTempoAcesso.
       */
      if (enableRequest && (hasFocus || ignorarFocus)) {
        handleReativarUsuario();
      } else if (enableRequest) {
        handleVerificarTempoAcesso();
      }
    }, poolingTimeInSeconds * 1000);
    return function () {
      clearInterval(intervalId);
    };
  }, [hasFocus, enableRequest]);

  // Atualizar o estado do focus da aplicação.
  (0, _react.useEffect)(function () {
    var onFocus = function onFocus() {
      handleReativarUsuario();
      setFocus(true);
    };
    var onBlur = function onBlur() {
      setFocus(false);
    };
    window.addEventListener("focus", onFocus);
    window.addEventListener("blur", onBlur);
    return function () {
      window.removeEventListener("focus", onFocus);
      window.removeEventListener("blur", onBlur);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(CacheAlert, {
    handleOnClose: handleOnClose,
    handleReativarUsuario: handleReativarUsuario,
    openAlert: openAlert,
    tempoRestanteSeg: tempoRestanteSeg
  }));
};
var SttCacheManager = function SttCacheManager(_ref11) {
  var config = _ref11.config,
    _ref11$onSync = _ref11.onSync,
    onSync = _ref11$onSync === void 0 ? function () {} : _ref11$onSync,
    _ref11$hasExternalTok = _ref11.hasExternalToken,
    hasExternalToken = _ref11$hasExternalTok === void 0 ? false : _ref11$hasExternalTok,
    redirectUrl = _ref11.redirectUrl,
    modo = _ref11.modo,
    _ref11$offline = _ref11.offline,
    offline = _ref11$offline === void 0 ? false : _ref11$offline;
  var _ref12 = MODOS[modo || config.auth_modo] || MODOS["LEGADO"],
    pathIFrame = _ref12.pathIFrame,
    ignorarFocus = _ref12.ignorarFocus,
    habilitarRestaurarTempoAcesso = _ref12.habilitarRestaurarTempoAcesso;
  var _useState11 = (0, _react.useState)(null),
    _useState12 = _slicedToArray(_useState11, 2),
    iFrameSrc = _useState12[0],
    setIFrameSrc = _useState12[1];
  if (hasExternalToken) {
    var query = useQuery();
    var queryHref = useHrefQuery();
    var accessToken = query.get('token') || queryHref.get('token');
    _cache.Cache.setAccessToken(accessToken);
  }
  (0, _react.useEffect)(function () {
    var query = useQuery();
    var queryHref = useHrefQuery();
    var accessToken = query.get('token') || queryHref.get('token');
    if (accessToken) {
      setIFrameSrc("".concat(config.url_base_oauth2).concat(pathIFrame, "?token=").concat(accessToken));
    } else {
      setIFrameSrc("".concat(config.url_base_oauth2).concat(pathIFrame));
    }
  }, []);

  // Para receber as mensagens do iFrame.
  (0, _react.useEffect)(function () {
    var messageListener = function messageListener(event) {
      var _event$data, _event$data2;
      if (!event) return;
      var acao = ((_event$data = event.data) === null || _event$data === void 0 ? void 0 : _event$data.acao) || null;
      var data = ((_event$data2 = event.data) === null || _event$data2 === void 0 ? void 0 : _event$data2.data) || null;
      var acaoFn = ActionFnMap[acao];
      if (acaoFn) acaoFn({
        data: data,
        config: config,
        onSync: onSync,
        redirectUrl: redirectUrl
      });
    };
    window.addEventListener("message", messageListener);

    // clean up
    return function () {
      return window.removeEventListener("message", messageListener);
    };
  }, []);

  // Quando offline, não precisa esperar o iFrame.
  if (offline) {
    onSync(true);
  }
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, habilitarRestaurarTempoAcesso && /*#__PURE__*/_react["default"].createElement(RestaurarTempoAcesso, {
    redirectUrl: redirectUrl,
    config: config,
    ignorarFocus: ignorarFocus
  }), iFrameSrc && /*#__PURE__*/_react["default"].createElement("iframe", {
    className: "stt-iframe-cachemanager",
    referrerPolicy: "unsafe-url",
    src: iFrameSrc,
    style: {
      width: 0,
      height: 0,
      border: 0,
      position: 'absolute'
    }
  }));
};
SttCacheManager.propTypes = {
  config: _propTypes["default"].object
};
var _default = SttCacheManager;
exports["default"] = _default;